import { useEffect, useState } from "react";
import _ from "lodash";
// import 'antd/dist/antd.css';
import { Table } from "antd";
import dataConstant from "../constants/dataConstant";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";
import DataConstant from "../constants/dataConstant";

const GridComponent = ({
  rowKey,
  columns,
  dataSource,
  getGridData,
  totalCount,
  scroll,
  deleteCallbackMethod,
  SearchText,
  pageNumber,
  enableRowSelection,
  onSelectChange,
  loading,
  expandedRowRender,
  tableRequest,
}) => {
  const [request, setRequest] = useState(
    JSON.parse(JSON.stringify(dataConstant.tableRequest)),
  );
  const [pagination, setPagination] = useState({
    current: dataConstant.pagination.pageNumber,
    defaultPageSize: dataConstant.pagination.defaultPageSize,
    showSizeChanger: dataConstant.pagination.showSizeChanger,
    pageSizeOptions: dataConstant.pagination.pageSizeOptions,
    total: 0,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [Columns, setColumns] = useState([]);

  useEffect(() => {
    setRequest(tableRequest);
    setPagination({ ...pagination, current: pageNumber, total: totalCount });
    setColumns(columns);
  }, [pageNumber, SearchText, totalCount, tableRequest]);

  const handleTableChange = (pager, filters, sorter) => {
    const { current, pageSize } = pager;

    setPagination({ ...pagination, current: current });
    setSelectedRowKeys([]);
    setIsMultipleDelete(false);

    const requestObject = {
      pageNumber: current,
      rowsPerPage: pageSize,
      SearchText,
      SearchColumns: [],
      sortColumns: {
        sortColumnName:
          sorter.field && sorter.order
            ? sorter.field
            : DataConstant.tableRequest.sortColumns.sortColumnName,
        sortOrder:
          (sorter.order === "descend" ? "desc" : "") ||
          (sorter.order === "ascend" ? "asc" : "") ||
          DataConstant.tableRequest.sortColumns.sortOrder,
      },
    };
    getGridData(requestObject, current);

    if (onSelectChange) {
      onSelectChange([], []);
    }
  };

  const pageRefresh = () => {
    getGridData(JSON.parse(JSON.stringify(dataConstant.tableRequest)));
    setPagination({
      current: dataConstant.pagination.pageNumber,
      defaultPageSize: dataConstant.pagination.defaultPageSize,
      showSizeChanger: dataConstant.pagination.showSizeChanger,
      pageSizeOptions: dataConstant.pagination.pageSizeOptions,
      total: 0,
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    });
    setSelectedRowKeys([]);
    setIsMultipleDelete(false);
  };

  const deleteCallback = () => {
    deleteCallbackMethod(selectedRowKeys, isMultipleDelete);
  };

  const onSelectChanges = (selectedRowKeys, selectedRows) => {
    if (selectedRowKeys.length > 0) {
      setSelectedRowKeys(selectedRowKeys);
      setIsMultipleDelete(true);
    } else {
      setSelectedRowKeys([]);
      setIsMultipleDelete(false);
    }

    if (onSelectChange) {
      onSelectChange(selectedRowKeys, selectedRows);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChanges,
    getCheckboxProps: (record) => ({
      disabled: record.isDefault,
    }),
  };
  return (
    <>
      <Table
        className="sm:px-12"
        rowKey={(record) => record[rowKey]}
        columns={Columns}
        dataSource={dataSource}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowSelection={enableRowSelection ? rowSelection : null}
        size="middle"
        scroll={scroll}
        bordered
        expandedRowRender={expandedRowRender}
        title={() => (
          <div className="text-right">
            {isMultipleDelete && (
              <Tooltip title={dataConstant.Delete}>
                <IconButton onClick={() => deleteCallback()}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={dataConstant.Refresh}>
              <IconButton onClick={pageRefresh}>
                <ReplayIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
      />
    </>
  );
};

export default GridComponent;
